import { useContext, useState } from 'react';
import styled from 'styled-components';
import { ApiContext } from '../../contexts/ApiContext';
import { useProductsByIds } from '../../hooks/useProductsByIds';
import { assetUrl } from '../../utils/assets';
import { formatPriceUsd } from '../../utils/price';
import Spinner from '../spinner/Spinner';

export default function ProductCard({ product, type }) {

    const { rates } = useContext(ApiContext);
    const { products, loading } = useProductsByIds({ product, type });
    const [showDescription, setShowDescription] = useState({});

    const toggleDescription = (id) => {
        setShowDescription(prevState => ({
            ...prevState,
            [id]: !prevState[id]
        }));
    };

    if (loading) {
        return <Spinner />;
    }

    if (products.length === 0) {
        return <h5 style={{ marginTop: '2rem' }}>No hay Datos disponibles para este producto</h5>;
    }

    return (
        <StyledProductCard>
            {products.map(item => {
                const { producto, precio, description } = item;
                const price = formatPriceUsd(precio, rates);

                return (
                    <div className="card" key={producto.id}>
                        <div className="logoInfo" onClick={() => toggleDescription(producto.id)}>
                            <i className="fa-solid fa-circle-info"></i>
                        </div>
                        {showDescription[producto.id] ? (
                            description && (
                                <div className="card-body" style={{ display: 'flex', alignItems: 'center' }}>
                                    <h5>{description}</h5>
                                </div>
                            )
                        ) : (
                            <>
                                {producto.imagen_grande &&
                                    <img src={assetUrl(producto.imagen_grande)}
                                        className="card-img-top"
                                        style={{ padding: '1rem' }}
                                        alt={`Imagen de ${producto.nombre_producto}`}
                                    />
                                }
                                <div className="card-body">
                                    <h4 className="card-title"><strong>{producto.nombre_producto}</strong></h4>
                                    <p className="card-cod">Código: </p><h6 style={{ minHeight: '3rem' }}>{producto.codigo}</h6>
                                    {price && <button className='btn btn-warning btnPrice'>{price}</button>}
                                </div>
                            </>
                        )}
                    </div>
                );
            })}
        </StyledProductCard>
    );
}

const StyledProductCard = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    justify-content: center;
    max-height: 530px;  /* Limitar la altura máxima del contenedor */
    overflow-y: auto;   /* Habilitar el scroll vertical */
    scroll-snap-type: y mandatory;  /* Habilitar el scroll snap vertical */

    .card {
        flex: 1 1 calc(50% - 1rem); /* 2 cards per row on mobile */
        max-width: calc(50% - 1rem);
        scroll-snap-align: center;  /* ajusta automaticamente el scoll en el centro de la siguiente fila */

        @media (min-width: 768px) {
            flex: 1 1 calc(33.33% - 1rem); /* 3 cards per row on desktop */
            min-width: calc(12rem - 1rem);
            max-width: calc(33.33% - 1rem);
        }

        @media (min-width: 992px) {
            flex: 1 1 calc(25% - 1rem); /* 4 cards per row on desktop */
            min-width: calc(13rem - 1rem);
            max-width: calc(25% - 1rem);
        }

        @media (min-width: 1200px) {
            flex: 1 1 calc(16.66% - 1rem); /* 6 cards per row on desktop */
            min-width: calc(15rem - 1rem);
            max-width: calc(16.66% - 1rem);
        }

        .card-img-top {
            width: 100%;
        }
    }
    .logoInfo {
        display: flex;
        justify-content: end;
        padding: 0.5rem;
        cursor: pointer;
        font-size: 1.2rem;
    }

    .btnPrice{
        width: -webkit-fill-available;
        padding: 0.6rem;
    }
    .card-title{
        min-height: 8rem;
        @media (min-width: 768px) {
            min-height: 5rem;
        }
    }
    .card-cod {
        margin-bottom: 0.2rem;
    }
`;
